import { render, staticRenderFns } from "./VArrowLeft.vue?vue&type=template&id=6e782a6e&"
import script from "./VArrowLeft.vue?vue&type=script&lang=js&"
export * from "./VArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports